import { Playground } from 'docz';
import { Row, Inline, InputPassword, Text } from 'react-nails';
import React from 'react';
export default {
  Playground,
  Row,
  Inline,
  InputPassword,
  Text,
  React
};